import { render, staticRenderFns } from "./BoxShow.vue?vue&type=template&id=3ac30ce4&scoped=true&"
import script from "./BoxShow.vue?vue&type=script&lang=js&"
export * from "./BoxShow.vue?vue&type=script&lang=js&"
import style0 from "./BoxShow.vue?vue&type=style&index=0&id=3ac30ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac30ce4",
  null
  
)

export default component.exports